
















  import { Component, Prop, Mixins } from 'vue-property-decorator'
  import BaseVue from '@/mixins/BaseVue'
import serviceModule from '@/store/modules/ServiceModule'
import VSelectWithValidation from '@/components/Inputs/VSelectWithValidation.vue'
import { UserInformations } from '@/services/connecteur'

@Component({
  components: {
    VSelectWithValidation
  }
})
export default class SNPSelect extends Mixins(BaseVue) {
  @Prop({ default: 0 })
  public id!: number

  public SNPList: UserInformations[] = new Array<UserInformations>()

  mounted () {
    this.updateSNPList()
  }

  public get snpError (): string {
    if (this.id) {
      const snps = this.SNPList.filter(x => x.id === this.id)

      if (!snps.length) {
        this.updateError(true)
        return this.$t('snpMapping.snpNotValid').toString()
      } else if (snps[0] && snps[0].desactivated) {
        this.updateError(true)
        return this.$t('snpMapping.snpDisabled').toString()
      }
    }
    this.updateError(false)
    return ''
  }

  public updateId (newValue: number) {
    this.$emit('update:id', newValue)
  }

  public updateError (newValue: boolean) {
    this.$emit('update:error', newValue)
  }

  public async updateSNPList () {
    try {
      this.SNPList = await serviceModule.userApi.getAllSNPs()
      } catch (error) {
        this.displayError(error)
      }
    }
  }
